import * as React from "react";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { AreaGroupType } from "../../../../../../../../Wrap/Constants/Enums/Domain/AreaGroupType";
import { InvestmentGeographicAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGeographicAllocationModel";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { AreaGroupTypeMap, Contents } from "../Resource/Contents";
import { RegionAllocationPopupView } from "./RegionAllocationPopupView";

interface IGeographicalAllocationMapProps extends React.Props<GeographicalAllocationMap> {
    mapData: Array<InvestmentGeographicAllocationModel>;
    accountSelectValue: string[];
    asAt: Date;
}

interface IGeographicalAllocationMapState {
    isShowRegionModal: boolean;
    areaCode: AreaGroupType;
}

export class GeographicalAllocationMap extends FormComponent<
    IGeographicalAllocationMapProps,
    IGeographicalAllocationMapState
> {
    constructor(props: IGeographicalAllocationMapProps) {
        super(props);
        this.state = {
            isShowRegionModal: false,
            areaCode: null,
        };
    }
    child: any = {};
    componentDidMount() {}
    private addEvent = new AdviserSiteTagManager().addEvent;

    private IsHaveValue(): boolean {
        const { mapData } = this.props;
        return mapData && mapData.length > 0;
    }

    private renderNoDataView(): JSX.Element {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="alert-info" role="alert">
                        <div className="alert-icon">
                            <div className="icon"></div>
                        </div>
                        <div className="alert-text">
                            <p>{Contents.noDataErrorMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderMap(): JSX.Element {
        const { mapData } = this.props;
        const scaleFactor = 14;
        mapData.sort((a, b) => {
            return a.Value > b.Value ? -1 : 1;
        });
        const maximumPercentageValue = Math.max.apply(
            Math,
            mapData.map(function (o) {
                return o.Value;
            })
        );
        return (
            <>
                <div className="insight-map">
                    <div className="image-cont">
                        <ul className="image" aria-hidden={true}>
                            {mapData.map((poi) => {
                                if (poi.AreaGroupType == AreaGroupType.CASH || poi.AreaGroupType == AreaGroupType.OTHER)
                                    {return null;}
                                return (
                                    <li
                                        key={poi.AreaGroupType}
                                        className={AreaGroupTypeMap[poi.AreaGroupType] + " poi"}
                                    >
                                        <span
                                            className="poi-dot"
                                            style={{
                                                width:
                                                    Math.round(
                                                        (((poi.Value / maximumPercentageValue) * 10 * 100) / 100) *
                                                            scaleFactor
                                                    ) + "px",
                                                zIndex: 100 - poi.Value, //the smaller circle the higher zIndex to prevent being covered by a larger circle
                                            }}
                                        ></span>
                                        <span className="poi-string" aria-hidden={true}></span>
                                    </li>
                                );
                            })}
                        </ul>
                        {mapData.map((poi) => {
                            return (
                                <div
                                    key={poi.AreaGroupType}
                                    className={AreaGroupTypeMap[poi.AreaGroupType] + " poi-desc"}
                                >
                                    {poi.AreaGroupType == AreaGroupType.CASH ||
                                    poi.AreaGroupType == AreaGroupType.OTHER ? (
                                        <span className="label">{poi.DisplayName}</span>
                                    ) : (
                                        <button
                                            className="hyperlink"
                                            onClick={() => {
                                                this.addEvent({
                                                    event: "insightstab_interaction",
                                                    eventParameters: {
                                                        eventCategory: eventCategoryForGTM.insightsTab,
                                                        eventAction: "interactions",
                                                        eventLabel: poi.DisplayName,
                                                    },
                                                });
                                                this.popupRegionAllocationModal(poi.AreaGroupType, poi.Value);
                                            }}
                                        >
                                            {poi.DisplayName}
                                        </button>
                                    )}
                                    <span className="value">{poi.Value.toFixed(2)}%</span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="row">
                    <div className="col-fluid">
                        <p className="text-size-14">
                            {Contents.ViewAllRegionNote}
                            <button
                                className="hyperlink"
                                onClick={() => {
                                    this.addEvent({
                                        event: "insightstab_interaction",
                                        eventParameters: {
                                            eventCategory: eventCategoryForGTM.insightsTab,
                                            eventAction: "interactions",
                                            eventLabel: "view all",
                                        },
                                    });
                                    this.popupRegionAllocationModal(undefined, 1);
                                }}
                            >
                                View all
                            </button>
                        </p>
                    </div>
                </div>
                {this.renderInvestmentDetailPopupModal()}
            </>
        );
    }

    private renderInvestmentDetailPopupModal(): JSX.Element {
        const { isShowRegionModal, areaCode } = this.state;
        const { accountSelectValue, asAt } = this.props;

        if (isShowRegionModal) {
            return (
                <RegionAllocationPopupView
                    showBox={isShowRegionModal}
                    callBack={() => {
                        this.setState({ isShowRegionModal: false });
                    }}
                    areaCode={areaCode}
                    accountSelectValue={accountSelectValue}
                    asAt={asAt}
                ></RegionAllocationPopupView>
            );
        } else {
            return null;
        }
    }

    private popupRegionAllocationModal(areaGroup?: AreaGroupType, allocation?: number) {
        const isCash = areaGroup != AreaGroupType.CASH;
        if (isCash && allocation) {
            this.setState({
                isShowRegionModal: true,
                areaCode: areaGroup,
            });
        }
    }

    render() {
        return this.IsHaveValue() ? this.renderMap() : this.renderNoDataView();
    }
}
